import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var pill = /*#__PURE__*/css(applyFont(typography.mini), " display:inline-flex;border-radius:3px;height:25px;background-color:", colors.neutral.background.pressed, ";color:", colors.neutral.heavy.default, ";align-items:center;white-space:nowrap;padding:0 10px;");
export var label = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var icon = /*#__PURE__*/css("margin:inherit;margin-left:14px;width:12px;height:12px;:hover{color:", colors.neutral.base.hover, ";cursor:pointer;}");